import type { CSSProperties } from 'react';

/**
 * The top bar inside a project: a soft tint of its colour over the page background, so text keeps
 * its contrast in light and dark mode, and a 2px bottom line in the full colour.
 */
export function projectTintStyle(colour: string): CSSProperties {
  return {
    backgroundColor: `color-mix(in oklab, ${colour} 12%, var(--background))`,
    borderBottomColor: colour,
    borderBottomWidth: 2,
  };
}
